<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="4.5" r="1.8" />
    <path d="M5.5 8.5c4.3 1.3 8.7 1.3 13 0" />
    <path d="M12 8v5" />
    <path d="m12 13-2.5 7" />
    <path d="m12 13 2.5 7" />
  </svg>
</template>
